import { render, staticRenderFns } from "./template.html?vue&type=template&id=ce9061fa&external"
import script from "./items.vue?vue&type=script&lang=js"
export * from "./items.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports